import {ButtonGroup, Card, DataStatus, IconButton} from 'platform/components';
import {Box, Right, Show} from 'platform/foundation';

import {useSelector} from 'react-redux';

import {selectBranchList} from '@dms/api/core';
import {
  CustomerSeriesDefinitionResponseBody,
  useGetCustomerSeriesDefinitionListQuery,
} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {ColumnType, selectSeries, SimpleTable, useRouter} from '@dms/teas';

import {composePath} from 'shared/web';

export const CustomerSeriesDefinitionList = () => {
  const router = useRouter();
  const {
    data: definitions,
    isLoading: isDefinitionsLoading,
    isError: isDefinitionsErrored,
  } = useGetCustomerSeriesDefinitionListQuery();
  const {
    data: {branchListItems: branchList} = {},
    isLoading: isBranchListLoading,
    isError: isBranchListErrored,
  } = useSelector(selectBranchList);
  const series = useSelector(selectSeries);

  const columns: ColumnType<CustomerSeriesDefinitionResponseBody>[] = [
    {
      Header: i18n.t('entity.seriesDefinition.labels.definitionName'),
      id: 'name',
    },
    {
      Header: i18n.t('entity.branch.labels.branch'),
      id: 'branch',
      Cell: ({row}) => {
        if (!row.branchId) {
          return i18n.t('general.labels.all');
        }

        return branchList
          ? (branchList.find(({id}: {id: string}) => id === row.branchId)?.marketingName ?? '')
          : '';
      },
    },
    {
      Header: i18n.t('entity.seriesDefinition.labels.customerDefinitionSeries'),
      id: 'definitionSeries',
      Cell: ({row}) => series.find(({id}) => id === row.seriesId)?.name ?? row.seriesId,
    },
    {
      Header: '',
      id: 'actions',
      width: 100,
      Cell: ({row}) => (
        <Box paddingVertical={3}>
          <Right>
            <ButtonGroup>
              <IconButton
                key="edit"
                size="small"
                icon="image/edit"
                onClick={() =>
                  router.push(
                    composePath(settingsRoutes.customerCodeDefinitionDetail, {
                      params: {id: row.id},
                    })
                  )
                }
              />
            </ButtonGroup>
          </Right>
        </Box>
      ),
    },
  ];

  return (
    <DataStatus
      isLoading={isDefinitionsLoading || isBranchListLoading}
      isError={isDefinitionsErrored || isBranchListErrored}
      minHeight={25}
    >
      <Show when={definitions && definitions.length === 0 ? definitions : null}>
        {(definitions) => (
          <Card title={i18n.t('entity.seriesDefinition.labels.definitions')}>
            <SimpleTable
              noZebra
              showRowDivider
              tdPadding="default"
              highlightRowOnHover
              rows={[
                {
                  data: definitions,
                },
              ]}
              getRowId={({id}) => id}
              columns={columns}
            />
          </Card>
        )}
      </Show>
    </DataStatus>
  );
};
